import * as types from './types';
import * as _ from 'lodash';

const INITIAL_STATE = {
  data: {},
  fetchError: null,
  fetching: false,
  submitting: false,
  submitted: false,
  submitError: null,
  deleting: false,
  deleted: false,
  deleteError: null,
};

export default (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case types.VENDOR_FETCHING:
      return {
        ...state,
        fetching: payload,
      };
    case types.VENDOR_FETCH:
      return {
        ...state,
        data: payload.vendorData,
        fetching: false,
      };
    case types.VENDOR_FETCH_ERROR:
      if (_.has(payload, 'response.data.Error')) {
        const fetchError = payload.response.data.Errors[0];
        return {
          ...state,
          fetchError,
        };
      } else {
        return {
          ...state,
          fetchError: {
            Title: 'Error',
            Message:
              'An error occurred while fetching this vendor. Please try again',
          },
        };
      }
    case types.VENDOR_SUBMITTING:
      return {
        ...state,
        submitting: payload,
      };
    case types.VENDOR_SUBMIT:
      return {
        ...state,
        submitted: true,
      };
    case types.VENDOR_SUBMIT_ERROR:
      if (_.has(payload, 'response.data.Errors')) {
        const submitError = payload.response.data.Errors[0];

        return {
          ...state,
          submitError,
        };
      }
      return {
        ...state,
        submitError: {
          Title: 'Error',
          Message:
            'An error occurred while saving this vendor. Please try again',
        },
      };
    case types.VENDOR_DELETING:
      return {
        ...state,
        deleting: payload,
      };
    case types.VENDOR_DELETE:
      return {
        ...state,
        deleted: true,
      };

    case types.VENDOR_DELETE_ERROR:
      if (_.has(payload, 'response.data.Errors')) {
        const deleteError = payload.response.data.Errors[0];

        return {
          ...state,
          deleteError,
        };
      }
      return {
        ...state,
        deleteError: {
          Title: 'Error',
          Message:
            'An error occurred while deleting this Vendor. Please try again',
        },
      };
    case types.VENDOR_CLEAR:
      return INITIAL_STATE;

    case types.VENDOR_CLEAR_ERROR_SUCCESS:
      return {
        ...state,
        fetchError: null,
        fetching: false,
        submitting: false,
        submitted: false,
        submitError: null,
        deleting: false,
        deleted: false,
        deleteError: null,
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/pages/inventory/vendorsetup/state/vendorDetails/reducer.js